"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8891],{

/***/ 10304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isShippingProtection; },
/* harmony export */   "Y": function() { return /* binding */ isNotShippingProtection; }
/* harmony export */ });
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49125);
/* harmony import */ var _data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68533);


var isShippingProtection = function(item) {
    return item.sku.includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_SHIELD_SKU */ .E) || item.sku.includes(_data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__/* .WORRY_FREE_DELIVERY_SKU */ .f);
};
var isNotShippingProtection = function(item) {
    return !isShippingProtection(item);
};


/***/ }),

/***/ 25720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51250);
/* harmony import */ var _helpers_checkIsExtendItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40136);








var getExtendingSku = function(sku) {
    return (0,_helpers_checkIsExtendItem__WEBPACK_IMPORTED_MODULE_3__.checkIsExtendItem)({
        sku: sku
    }) ? sku.split(_data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_4__/* .EXTEND_SKU */ .J)[1] : "";
};
var sumQuantitiesWithSku = function(target) {
    return function(items) {
        return items.reduce(function(acc, param) {
            var sku = param.sku, quantity = param.quantity;
            return sku === target ? acc + quantity : acc;
        }, 0);
    };
};
var getLastPromiseToResolve = function(promises) {
    return promises.sort(function(param, param1) {
        var cartA = param.newCart, cartB = param1.newCart;
        if (cartA && !cartB) {
            return 1;
        }
        if (!cartA && cartB) {
            return -1;
        }
        if (cartA && cartB) {
            return new Date(cartA.updatedTime) > new Date(cartB.updatedTime) ? 1 : -1;
        }
        return 0;
    })[0];
};
var fetchModules = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, getCart, rawCartDeleteItem, rawCartUpdateQuantity;
        return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(6511), __webpack_require__.e(9683)]).then(__webpack_require__.bind(__webpack_require__, 36511)),
                            __webpack_require__.e(/* import() */ 7012).then(__webpack_require__.bind(__webpack_require__, 87012)),
                            __webpack_require__.e(/* import() */ 1365).then(__webpack_require__.bind(__webpack_require__, 11365)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    getCart = ref[0].getCart;
                    rawCartDeleteItem = ref[1].rawCartDeleteItem;
                    rawCartUpdateQuantity = ref[2].rawCartUpdateQuantity;
                    return _ctx.abrupt("return", {
                        getCart: getCart,
                        rawCartDeleteItem: rawCartDeleteItem,
                        rawCartUpdateQuantity: rawCartUpdateQuantity
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchModules() {
        return _ref.apply(this, arguments);
    };
}();
var idAndQuantityToOperationPromise = function(param) {
    var rawCartUpdateQuantity = param.rawCartUpdateQuantity, rawCartDeleteItem = param.rawCartDeleteItem;
    return function(cartId) {
        return function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), itemId = _param[0], quantity = _param[1];
            return quantity > 0 ? rawCartUpdateQuantity({
                cartId: cartId,
                itemId: itemId,
                quantity: quantity
            }) : rawCartDeleteItem({
                cartId: cartId,
                itemId: itemId
            });
        };
    };
};
var normalizeWarrantiesQTY = function(modules) {
    return function(cartId) {
        return function(idsToAlsoApllyOperator) {
            return Promise.all(idsToAlsoApllyOperator.map(idAndQuantityToOperationPromise(modules)(cartId)));
        };
    };
};
var withExtendWarrantyNormalization = function(operator) {
    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _len, args, _key, modules, cartOperationResult, newCart, success, extendWarrantyItems, idsToAlsoApllyOperator, _args = arguments;
        return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    for(_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _args[_key];
                    }
                    _ctx.next = 3;
                    return fetchModules();
                case 3:
                    modules = _ctx.sent;
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return operator.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(args));
                case 7:
                    cartOperationResult = _ctx.sent;
                    newCart = cartOperationResult.newCart, success = cartOperationResult.success;
                    if (!(!success || !newCart)) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", cartOperationResult);
                case 11:
                    extendWarrantyItems = newCart.lineItems.filter(_helpers_checkIsExtendItem__WEBPACK_IMPORTED_MODULE_3__.checkIsExtendItem);
                    idsToAlsoApllyOperator = extendWarrantyItems.reduce(function(acc, item) {
                        var expectedquantity = sumQuantitiesWithSku(getExtendingSku(item.sku))(newCart.lineItems);
                        if (expectedquantity !== item.quantity) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(acc).concat([
                                [
                                    item.id,
                                    expectedquantity
                                ], 
                            ]);
                        }
                        return acc;
                    }, []);
                    if (idsToAlsoApllyOperator.length) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", cartOperationResult);
                case 15:
                    _ctx.t0 = getLastPromiseToResolve;
                    _ctx.next = 18;
                    return normalizeWarrantiesQTY(modules)(newCart.id)(idsToAlsoApllyOperator);
                case 18:
                    _ctx.t1 = _ctx.sent;
                    return _ctx.abrupt("return", (0, _ctx.t0)(_ctx.t1));
                case 22:
                    _ctx.prev = 22;
                    _ctx.t2 = _ctx["catch"](4);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to Normalize cart with Extend");
                case 25:
                    _ctx.next = 27;
                    return modules.getCart();
                case 27:
                    _ctx.t3 = _ctx.sent;
                    return _ctx.abrupt("return", {
                        success: false,
                        newCart: _ctx.t3
                    });
                case 29:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                22
            ]
        ]);
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (withExtendWarrantyNormalization);


/***/ }),

/***/ 15983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getCartFromExtendInterface; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var getCartFromExtendInterface = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!window.Extend || !window.ExtendBigCommerce)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 2:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        window.ExtendBigCommerce.getCart(function(error, cart) {
                            return error ? reject(error) : resolve(cart);
                        });
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCartFromExtendInterface() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (getCartFromExtendInterface);


/***/ }),

/***/ 94629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ExtendWarranty": function() { return /* binding */ ExtendWarranty; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _getCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15983);
/* harmony import */ var _openModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31433);




var ExtendWarranty = {
    /**
   * @param {Object} prop
   * @param {String} prop.sku - The product sku
   * @param {String} prop.variantSku - The variant sku
   */ initXPDP: function initXPDP(param) {
        var sku = param.sku, variantSku = param.variantSku;
        window.ExtendWarrantyService = ExtendWarranty;
        // Add timeout to ensure add to cart button has finished rendering
        this.productOptionsElement = document.querySelector("#add-to-cart-form .product-options");
        this.addToCartButton = document.querySelector("#form-action-addToCart");
        try {
            window.Extend.buttons.destroyAll();
        } catch (e) {
            console.error(e);
        }
        window.Extend.buttons.render("#extend-offer", {
            referenceId: sku
        });
        this.processVariant(variantSku);
    },
    processVariant: function processVariant(sku) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        (ref1 = (ref = window.Extend) === null || ref === void 0 ? void 0 : ref.buttons.instance("#extend-offer")) === null || ref1 === void 0 ? void 0 : ref1.setActiveProduct(sku);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    getCart: _getCart__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    openModal: _openModal__WEBPACK_IMPORTED_MODULE_2__["default"],
    getOffer: function getOffer(sku) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", window.Extend.getOffer(sku));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    isExtendProduct: function isExtendProduct(sku) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var offer;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return window.Extend.getOffer(sku);
                    case 2:
                        offer = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(offer.product.title));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    createCartWithProduct: function createCartWithProduct(productId) {
        var data = JSON.stringify({
            action: "add",
            product_id: productId,
            "qty[]": 1
        });
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.addEventListener("readystatechange", function() {
                if (this.readyState === this.DONE) {
                    resolve({
                        status: xhr.status,
                        data: xhr.response
                    });
                }
            });
            xhr.addEventListener("error", function(event) {
                reject(event);
            });
            // TODO: Migrate to V3
            xhr.open("POST", "remote/v1/cart/add");
            xhr.setRequestHeader("content-type", "application/json");
            xhr.responseType = "json";
            xhr.send(data);
        });
    },
    initXMiniCart: function initXMiniCart() {
        if (window.Extend && window.ExtendBigCommerce) {
            window.ExtendBigCommerce.getCart(function(error, cart) {
                if (cart) {
                    window.ExtendBigCommerce.normalizeCart({
                        cart: cart,
                        balance: true
                    }, function() {});
                }
            });
        }
    },
    extendCatalogOffers: function extendCatalogOffers(cartUrl) {
        if (window.Extend && window.ExtendBigCommerce) {
            document.querySelector('[data-button-type="add-cart"]').on("click", function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var sku = e.currentTarget.getAttribute("data-product-sku");
                var productId = e.currentTarget.getAttribute("data-product-id");
                var href = e.currentTarget.getAttribute("href");
                window.ExtendBigCommerce.getCart(function(_, cart) {
                    if (cart) {
                        window.Extend.modal.open({
                            referenceId: sku,
                            onClose: function(plan, product) {
                                if (plan && product) {
                                    window.ExtendBigCommerce.addPlanToCart({
                                        sku: sku,
                                        plan: plan,
                                        cart: cart
                                    }, function() {
                                        window.location = href;
                                    });
                                } else {
                                    window.location = href;
                                }
                            }
                        });
                    } else {
                        ExtendWarranty.createCartWithProduct(productId).then(function(res) {
                            if (!res.data) {
                                window.location = cartUrl;
                                return;
                            }
                            window.Extend.modal.open({
                                referenceId: sku,
                                onClose: function(plan, product) {
                                    if (plan && product) {
                                        window.ExtendBigCommerce.addPlanToCart({
                                            sku: sku,
                                            plan: plan
                                        }, function() {
                                            window.location = cartUrl;
                                        });
                                    } else {
                                        window.location = cartUrl;
                                    }
                                }
                            });
                        });
                    }
                });
            });
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ExtendWarranty);


/***/ }),

/***/ 31433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "openExtendWarrantyModal": function() { return /* binding */ openExtendWarrantyModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Cart_getCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36511);
/* harmony import */ var _Cart_withExtendWarrantyNormalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25720);
/* harmony import */ var _getCart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15983);





var rawOpenExtendWarrantyModal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var sku, quantity, cart;
        return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sku = param.sku, quantity = param.quantity;
                    _ctx.next = 3;
                    return (0,_getCart__WEBPACK_IMPORTED_MODULE_3__/* .getCartFromExtendInterface */ .l)();
                case 3:
                    cart = _ctx.sent;
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        window.Extend.modal.open({
                            referenceId: sku,
                            onClose: function(plan) {
                                window.ExtendBigCommerce.addPlanToCart({
                                    sku: sku,
                                    plan: plan,
                                    quantity: quantity,
                                    cart: cart
                                }, function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
                                        return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (!error) {
                                                        _ctx.next = 9;
                                                        break;
                                                    }
                                                    _ctx.t1 = resolve;
                                                    _ctx.next = 4;
                                                    return (0,_Cart_getCart__WEBPACK_IMPORTED_MODULE_1__.getCart)();
                                                case 4:
                                                    _ctx.t2 = _ctx.sent;
                                                    _ctx.t3 = {
                                                        success: false,
                                                        newCart: _ctx.t2
                                                    };
                                                    _ctx.t0 = (0, _ctx.t1)(_ctx.t3);
                                                    _ctx.next = 15;
                                                    break;
                                                case 9:
                                                    _ctx.t4 = resolve;
                                                    _ctx.next = 12;
                                                    return (0,_Cart_getCart__WEBPACK_IMPORTED_MODULE_1__.getCart)();
                                                case 12:
                                                    _ctx.t5 = _ctx.sent;
                                                    _ctx.t6 = {
                                                        success: true,
                                                        newCart: _ctx.t5
                                                    };
                                                    _ctx.t0 = (0, _ctx.t4)(_ctx.t6);
                                                case 15:
                                                    return _ctx.abrupt("return", _ctx.t0);
                                                case 16:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(error) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            }
                        });
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function rawOpenExtendWarrantyModal(_) {
        return _ref.apply(this, arguments);
    };
}();
var openExtendWarrantyModal = (0,_Cart_withExtendWarrantyNormalization__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(rawOpenExtendWarrantyModal);
/* harmony default export */ __webpack_exports__["default"] = (openExtendWarrantyModal);


/***/ }),

/***/ 16033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$z": function() { return /* binding */ setOptOut; },
/* harmony export */   "Lt": function() { return /* binding */ setOptIn; },
/* harmony export */   "kg": function() { return /* binding */ clearCustomerOptOut; },
/* harmony export */   "rq": function() { return /* binding */ customerOptedOutOfWFD; }
/* harmony export */ });
// we will use session storage to store the customer's decision to add/remove delivery protection
var setOptOut = function() {
    return localStorage.setItem("WORRY_FREE_DELIVER", "false");
};
var setOptIn = function() {
    return localStorage.setItem("WORRY_FREE_DELIVER", "true");
};
var clearCustomerOptOut = function() {
    return localStorage.removeItem("WORRY_FREE_DELIVER");
};
var customerOptedOutOfWFD = function() {
    return localStorage.getItem("WORRY_FREE_DELIVER") === "false";
};


/***/ })

}]);